// components/BankOfferModal.js
import React from "react";

export default function BankOfferModal({ offer, onClose, banksLogos, banksAddresses }) {
  if (!offer) return null;

  const bankKey = offer.bankName?.toLowerCase();
  const iconSrc = bankKey && banksLogos[bankKey] ? banksLogos[bankKey] : offer.icon;
  const address = bankKey && banksAddresses[bankKey];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          aria-label="Close modal"
          type="button"
        >
          ❌
        </button>
        <img
          src={iconSrc}
          alt={offer.bankName}
          className="h-12 mb-4 mx-auto"
        />
        <h3 className="text-xl font-semibold text-center mb-2">
          {offer.vendor && offer.vendor.includes("##") ? offer.category : offer.vendor}
        </h3>
        <p className="text-center mb-2">{offer.offer}</p>
        {offer.expiryDttm && (
          <p className="text-center text-sm text-gray-500">
            Expires: {new Date(offer.expiryDttm.toDate()).toLocaleDateString()}
          </p>
        )}
        {offer.minimumSpend && (
          <p className="text-center text-sm text-gray-600 mt-1">
            Minimum Spend: {offer.minimumSpend}
          </p>
        )}
        {offer.maximumOffer && (
          <p className="text-center text-sm text-gray-600">
            Max Discount: {offer.maximumOffer}
          </p>
        )}
        {address && (
          <p className="text-center mt-4">
            <a
              href={address}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline font-semibold"
            >
              Visit Bank Site
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
